import { render, staticRenderFns } from "./CalendarListTab.vue?vue&type=template&id=ff8fdb06&"
import script from "./CalendarListTab.vue?vue&type=script&lang=js&"
export * from "./CalendarListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports